export const blockIconsTransportationPedalBikeNew = (
	<span className='material-symbols-outlined'>pedal_bike</span>
);
